import isImage from 'is-image'

export default {
  install: (app) => {
    app.config.globalProperties.$isImage = isImage
    app.provide('isImage', isImage)
  },
}
